<template>
<div 
  class="main-content-items"
  :style="{ 
    'color': `${customTextColorContent} !important`,
    padding: item.Padding
  }">
  <item-title
    v-if="item.Type === 2 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :customTextColorContent="customTextColorContent"
  />
  <item-space
    v-else-if="item.Type === 3 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-image
    v-else-if="item.Type === 4 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-iframe
    v-else-if="item.Type === 5 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-alert
    v-else-if="item.Type === 6 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-gallery
    v-else-if="item.Type === 7 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-video
    v-else-if="item.Type === 8 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-meteo
    v-else-if="item.Type === 9 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-map
    v-else-if="item.Type === 10 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-twitter
    v-else-if="item.Type === 11 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-facebook
    v-else-if="item.Type === 12 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-activity
    v-else-if="item.Type === 13 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-pdf
    v-else-if="item.Type === 14 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :customTextColorContent="customTextColorContent"
  />
  <item-timeline
    v-else-if="item.Type === 15 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-text
    v-else-if="item.Type === 16 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :columnType="columnType"
    :customTextColorContent="customTextColorContent"
  />
  <item-contact
    v-else-if="item.Type === 17 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :customTextColorContent="customTextColorContent"
  />
  <item-divider
    v-else-if="item.Type === 18 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-show
    v-else-if="item.Type === 19 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-site
    v-else-if="item.Type === 20 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-agenda
    v-else-if="item.Type === 21 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-parrilla
    v-else-if="item.Type === 22 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :menuID="menuID"
  />
  <item-wifi
    v-else-if="item.Type === 23 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-property
    v-else-if="item.Type === 24 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-commercial
    v-else-if="item.Type === 25 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-queue
    v-else-if="item.Type === 26 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-food-drink
    v-else-if="item.Type === 27 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :config="config"
    v-show="showFoodDrink"
  />
  <item-link-domain
    v-else-if="item.Type === 28 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-form
    v-else-if="item.Type === 29 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-product-service
    v-else-if="item.Type === 30 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-pdf-translate
    v-else-if="item.Type === 31 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-link-external
    v-else-if="item.Type === 32 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-channel-list
    v-else-if="item.Type === 33 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-activity-acttiv
    v-else-if="item.Type === 34 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-poll
    v-else-if="item.Type === 35 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-instagram
    v-else-if="item.Type === 36 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-icon-list
    v-else-if="item.Type === 37 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
    :customTextColorContent="customTextColorContent"
  />
  <item-dropdown-button
    v-else-if="item.Type === 38 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-dfiles
    v-else-if="item.Type === 39 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-rcovid
    v-else-if="item.Type === 40 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-image-translate
    v-else-if="item.Type === 41 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-iberostar-food
    v-else-if="item.Type === 42 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-icons
    v-else-if="item.Type === 43 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-hsconsulting
    v-else-if="item.Type === 44 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-brochure
    v-else-if="item.Type === 45 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-infoten
    v-else-if="item.Type === 46 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-booking-my-bookings
    v-else-if="item.Type === 47 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-booking-my-bookings
    v-else-if="item.Type === 47 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-booking-activities
    v-else-if="item.Type === 48 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-menu-ext-food
    v-else-if="item.Type === 49 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :config="config"
    :locale="locale"
  />

  <item-booking-attendance
    v-else-if="item.Type === 50 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />
  <item-weekly-menu
    v-else-if="item.Type === 51 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :config="config"
  />
  <item-requests-issues
    v-else-if="(item.Type === 52 || item.Type === 53) && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :config="config"
  />
  <item-form-cio
    v-else-if="item.Type === 54 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :data="item"
  />

  <item-55-dviewcontent-messages
    v-else-if="item.Type === 55 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
  />

  <item-56-servatur
    v-else-if="item.Type === 56 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
  />

  <item-57-interactive-maps
    v-else-if="item.Type === 57 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item-58-abama-request-reservation
    v-else-if="item.Type === 58 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item-59-effilabel
    v-else-if="item.Type === 59 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item-60-effiwaste
    v-else-if="item.Type === 60 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item-62-chekin
    v-else-if="item.Type === 62 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item63QAndA
    v-else-if="item.Type === 63 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item64MediaFeed
    v-else-if="item.Type === 64 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <item65AbamaLinkRoom
    v-else-if="item.Type === 65 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />
  <item66AbamaRequest
    v-else-if="item.Type === 66 && ((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))"
    :content="item"
    :locale="locale"
    :isDesktop="!isMobile"
    :config="config"
  />

  <div v-else-if="((!isMobile && !item.HideDesktop) || (isMobile && !item.HideMobile))">{{item}}</div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import ItemTitle from '../views/public/mobile/customMenu/items/Title'
  import ItemSpace from '../views/public/mobile/customMenu/items/Space'
  import ItemImage from '../views/public/mobile/customMenu/items/Image'
  import ItemIframe from '../views/public/mobile/customMenu/items/Iframe'
  import ItemAlert from '../views/public/mobile/customMenu/items/Alert'
  import ItemGallery from '../views/public/mobile/customMenu/items/Gallery'
  import ItemVideo from '../views/public/mobile/customMenu/items/Video'
  import ItemMeteo from '../views/public/mobile/customMenu/items/Meteo'
  import ItemMap from '../views/public/mobile/customMenu/items/Map'
  import ItemTwitter from '../views/public/mobile/customMenu/items/twitter/Index'
  import ItemFacebook from '../views/public/mobile/customMenu/items/facebook/Index'
  import ItemActivity from '../views/public/mobile/customMenu/items/activity/Index'
  import ItemPdf from '../views/public/mobile/customMenu/items/PDF'
  import ItemTimeline from '../views/public/mobile/customMenu/items/timeline/Index'
  import ItemText from '../views/public/mobile/customMenu/items/Text'
  import ItemContact from '../views/public/mobile/customMenu/items/contact/Index'
  import ItemDivider from '../views/public/mobile/customMenu/items/Divider'
  import ItemShow from '../views/public/mobile/customMenu/items/show/Index'
  import ItemSite from '../views/public/mobile/customMenu/items/Site'
  import ItemAgenda from '../views/public/mobile/customMenu/items/agenda/Index'
  import ItemParrilla from '../views/public/mobile/customMenu/items/parrilla/Index'
  import ItemWifi from '../views/public/mobile/customMenu/items/Wifi'
  import ItemProperty from '../views/public/mobile/customMenu/items/property/Index'
  import ItemCommercial from '../views/public/mobile/customMenu/items/commercial/Index'
  import ItemQueue from '../views/public/mobile/customMenu/items/Queue'
  import ItemFoodDrink from '../views/public/mobile/customMenu/items/foodDrink/Index'
  import ItemLinkDomain from '../views/public/mobile/customMenu/items/LinkDomain'
  import ItemForm from '../views/public/mobile/customMenu/items/ItemForm'
  import ItemProductService from '../views/public/mobile/customMenu/items/productService/Index'
  import ItemPdfTranslate from '../views/public/mobile/customMenu/items/PDFTranslate'
  import ItemLinkExternal from '../views/public/mobile/customMenu/items/LinkExternal'
  import ItemChannelList from '../views/public/mobile/customMenu/items/ChannelList'
  import ItemActivityActtiv from '../views/public/mobile/customMenu/items/activityActtiv/Index'
  import ItemPoll from '../views/public/mobile/customMenu/items/poll/Index'
  import ItemInstagram from '../views/public/mobile/customMenu/items/instagram/Index'
  import ItemIconList from '../views/public/mobile/customMenu/items/IconList'
  import ItemDropdownButton from '../views/public/mobile/customMenu/items/dropdownButton/Index'
  import ItemDfiles from '../views/public/mobile/customMenu/items/dfiles/Index'
  import ItemRcovid from '../views/public/mobile/customMenu/items/RCovid'
  import ItemImageTranslate from '../views/public/mobile/customMenu/items/ImageTranslate'
  import ItemIberostarFood from '../views/public/mobile/customMenu/items/iberostarFood/Index'
  import ItemIcons from '../views/public/mobile/customMenu/items/Icons'
  import ItemHsconsulting from '../views/public/mobile/customMenu/items/Hsconsulting'
  import ItemBrochure from '../views/public/mobile/customMenu/items/Brochure'
  import ItemInfoten from '../views/public/mobile/customMenu/items/Infoten'
  import ItemBookingMyBookings from '../views/public/mobile/customMenu/items/bookingMyBookings/Index'
  import ItemBookingActivities from '../views/public/mobile/customMenu/items/bookingActivities/Index'
  import ItemMenuExtFood from '../views/public/mobile/customMenu/items/item49MenuExtFood/Index'
  import ItemBookingAttendance from '../views/public/mobile/customMenu/items/bookingAttendance/Index'
  import ItemWeeklyMenu from '../views/public/mobile/customMenu/items/weeklyMenu/Index'
  import ItemRequestsIssues from '../views/public/mobile/customMenu/items/item52Requests/Index'
  import ItemFormCio from '../views/public/mobile/customMenu/items/item54FormCio/Index'
  import Item55DviewcontentMessages from '../views/public/mobile/customMenu/items/Item55DviewcontentMessages'
  import Item56Servatur from '../views/public/mobile/customMenu/items/Item56Servatur'
  import Item57InteractiveMaps from '../views/public/mobile/customMenu/items/item57InteractiveMaps/Index'
  import Item58AbamaRequestReservation from '../views/public/mobile/customMenu/items/AbamaRequestReservation'
  import Item59Effilabel from '../views/public/mobile/customMenu/items/Item59Effilabel'
  import Item60Effiwaste from '../views/public/mobile/customMenu/items/Item60Effiwaste'
  import Item62Chekin from '../views/public/mobile/customMenu/items/Item62Chekin'
  import Item63QAndA from '../views/public/mobile/customMenu/items/Item63QAndA'
  import Item64MediaFeed from '../views/public/mobile/customMenu/items/item64MediaFeed/Index'
  import Item65AbamaLinkRoom from '../views/public/mobile/customMenu/items/Item65AbamaLinkRoom'
  import Item66AbamaRequest from '../views/public/mobile/customMenu/items/Item66AbamaRequest'

  export default {
    name: 'Items',
    components: {
      // ItemDemo,
      ItemTitle,
      ItemSpace,
      ItemImage,
      ItemIframe,
      ItemAlert,
      ItemGallery,
      ItemVideo,
      ItemMeteo,
      ItemMap,
      ItemTwitter,
      ItemFacebook,
      ItemActivity,
      ItemPdf,
      ItemTimeline,
      ItemText,
      ItemContact,
      ItemDivider,
      ItemShow,
      ItemSite,
      ItemAgenda,
      ItemParrilla,
      ItemWifi,
      ItemProperty,
      ItemCommercial,
      ItemQueue,
      ItemFoodDrink,
      ItemLinkDomain,
      ItemForm,
      ItemProductService,
      ItemPdfTranslate,
      ItemLinkExternal,
      ItemChannelList,
      ItemActivityActtiv,
      ItemPoll,
      ItemInstagram,
      ItemIconList,
      ItemDropdownButton,
      ItemDfiles,
      ItemRcovid,
      ItemImageTranslate,
      ItemIberostarFood,
      ItemIcons,
      ItemHsconsulting,
      ItemBrochure,
      ItemInfoten,
      ItemBookingMyBookings,
      ItemBookingActivities,
      ItemMenuExtFood,
      ItemBookingAttendance,
      ItemWeeklyMenu,
      ItemRequestsIssues,
      ItemFormCio,
      Item55DviewcontentMessages,
      Item56Servatur,
      Item57InteractiveMaps,
      Item58AbamaRequestReservation,
      Item59Effilabel,
      Item60Effiwaste,
      Item62Chekin,
      Item63QAndA,
      Item64MediaFeed,
      Item65AbamaLinkRoom,
      Item66AbamaRequest,
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      menuID: {
        type: String,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      },
      columnType: {
        type: String,
        required: false,
        default: 'xs12'
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data () {
      return {
        showFoodDrink: true,
        config: null,
      }
    },
    computed: {
      ...mapState('app',['locale', 'selectedAllergenFilters']),
      dtouchWorkspace () {
        return utils.getWorkspaceIdentification()
      },
    },
    watch: {
      selectedAllergenFilters (v) {
        this.checkAllergens(this.item.FoodAllergens, v)
        // this.showFoodDrink = true
        // for(const element of (v)) {
        //   if (this.item.FoodAllergens.indexOf(element) >= 0) this.showFoodDrink = false
        // }
      },
      'item.FoodAllergens' (v) {
        this.checkAllergens(v, this.selectedAllergenFilters)        
      }
    },
    mounted() {
      this.getConfig()
      this.checkAllergens(this.item.FoodAllergens, this.selectedAllergenFilters)    
    },
    methods: {
      getConfig () {
        try {

        const urlBase = process.env.VUE_APP_API_URL_DTOUCH
        const url = `${window.location.protocol}//${urlBase}/v1/public/workspaces/${this.dtouchWorkspace}`
        fetch(url, { 
          method: 'get', 
          headers: new Headers({
            'Content-Type': 'application/json'
          }), 
        })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          if (!data || data.length === 0) return
          const aux = JSON.parse(JSON.stringify(data.shift()))
          if (aux && aux.Languages) aux.Languages = aux.Languages.split(',')
          else aux.Languages = ["es"]
          this.config = aux
        })
        } catch (error) {
          console.log(error)
        }
      },
      checkAllergens (foodAllergens, selectedAllergens) {
        if (foodAllergens) {
          this.showFoodDrink = true
          for(const element of (selectedAllergens)) {
            if (foodAllergens.indexOf(element) >= 0) this.showFoodDrink = false
          }
        }        
      }
    }
  }
</script>
